<template>
<v-container>
    <v-card width="100%">
    <v-icon @click="refreshPage()">refresh</v-icon>
    </v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 md4 lg3 xl2  v-for="(Girl,i) in getGirlsWithThumbs" :key="i">
            <v-card @click="gotclick(i)">
        <v-img style="z-index: 1; background-color: white;" height="300" @error="hideme(i)" :src="Girl.ImageURL"></v-img>
        <v-card-title class='headline'>{{ Girl.Name }} </v-card-title>
    </v-card> 
    </v-flex>
    </v-layout>
    </v-container>
    </v-container>
</template>

<script>
    import axios from 'axios'
    /* eslint no-console: 0 */

    export default {
        data: function() {
            return {
                Girls: [],
                page: 1
            }
        },
        watch: {

        },
        mounted: function() {

            this.refreshPage();
        },

        methods: {
            refreshPage: function() {
                axios.get("https://cdn.gonewildreplay.com/cdn/getRandomImages/" + this.page).then(this.gotNewest);
            },
            gotNewest: function(response) {
                this.Girls = response.data;
                console.log("GOt newest");
                console.log(response.data);

            },
            hideme: function(i) {
                var tmp = [];
                for (var key in this.Girls) {
                    if (key != i) {
                        tmp.push(this.Girls[key])
                    }
                }
                this.Girls = tmp;
            },
            gotclick: function(i) {
                this.$router.push("/girl/" + this.Girls[i].Name);
            },


        },
        computed: {
            getGirlsWithThumbs: function() {
                var x = [];
                for (var key in this.Girls) {
                    var g = {}
                    g.Name = this.Girls[key].Name;
                    g.ImageURL = "https://cdn.gonewildreplay.com/cdn/thumb/" + this.Girls[key].ImageURL;
                    g.ImageCount = this.Girls[key].ImageCount;
                    x.push(g);
                }
                return (x);
            }
        }

    }
</script>

<style>
</style>
